import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAsync } from 'react-use';
import Select from '__components/Inputs/Select';
import { useErrors } from '../../../hooks/useErrors';
import { getDataQAForInput } from '__components/Inputs/helpers';
import ActivityService from 'services/ActivityService';
import { FORCE_ALL_RECORDS_SIZE } from 'services/helpers';
import { GenericOption } from 'pages/SmartConnectors/types';
import ApplySelectButton from '__components/Inputs/Select/ApplyButton';
import ClearSelectButton from '__components/Inputs/Select/ClearButton';

export const ActivitySelect: FC<{
  value?: { id: string; name: string };
  onChange: (value: GenericOption) => void;
  disabled: boolean;
  margin?: boolean;
}> = ({ value, onChange, disabled, margin }) => {
  const { t } = useTranslation();

  const { value: activities = [], loading } = useAsync<
    () => Promise<
      {
        value: string;
        label: string;
      }[]
    >
  >(async () => {
    const { results } = await ActivityService.v2GetActivities({
      params: {
        enabled: true,
        ordering: 'name',
        page_size: FORCE_ALL_RECORDS_SIZE,
      },
    });
    return results.map(({ id, name }: { id: string; name: string }) => ({
      value: id,
      label: name,
    }));
  }, []);

  const { clearError, validate, error } = useErrors('activity_object');

  const handleChange = (value: GenericOption) => {
    onChange(value);
    clearError();
  };

  return (
    <Select
      label={t('Choose Activity Object')}
      placeholder={t('Choose Activity')}
      error={error}
      validate={validate}
      loadItems={loading}
      value={value ? { value: value.id, label: value.name } : null}
      onChange={handleChange}
      options={activities}
      required
      disabled={disabled}
      {...getDataQAForInput('smart-connector-activity-object', 'dropdown')}
      margin={margin}
      menuRightButton={<ApplySelectButton />}
      menuLeftButton={<ClearSelectButton />}
    />
  );
};
